// src/components/UserTable.jsx
import React from 'react';
import { ClipboardList, Eye } from 'lucide-react';
import { encodeId } from '../../utills/idUtils';
import { useNavigate } from 'react-router-dom';


const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

const formatSource = (type) => {
    if (type === 'self') return 'Direct';
    if (type === 'participant') return 'Invite';
    return 'N/A';
};

const UserTable = ({ users, onSeeProfile, onSeeCampaigns }) => {



    return (
        <div className="overflow-x-auto">
            <table className="w-full border-collapse">
                <thead>
                    <tr className="bg-blue-100">
                        <th className="text-left p-3 text-blue-700 hidden md:table-cell">ID</th>
                        <th className="text-left p-3 text-blue-700">Name</th>
                        <th className="text-left p-3 text-blue-700">Email</th>
                        <th className="text-left p-3 text-blue-700">Registered On</th>
                        <th className="text-left p-3 text-blue-700">Source</th>
                        <th className="text-left p-3 text-blue-700">Self-Assessment</th>
                        <th className="text-left p-3 text-blue-700">360 Assessment</th>
                        <th className="text-left p-3 text-blue-700">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {users && users?.length > 0 && users.map((user) => (
                        <tr
                            key={user.user_id}
                            className="border-b border-blue-100 hover:bg-blue-50 transition"
                        >
                            <td className="p-3 hidden md:table-cell">{user.user_id}</td>
                            <td className="p-3">
                                <button
                                    onClick={() => onSeeCampaigns(user.user_id)}
                                    className="text-blue-700 hover:underline hover:text-blue-900"
                                >
                                    {user.first_name}
                                </button>
                            </td>

                            <td className="p-3">{user.user_name}</td>
                            <td className="p-3">{user.created_time ? formatDate(user.created_time) : 'N/A'}</td>
                            <td className="p-3">{formatSource(user.invitation_type)}</td>
                            <td className="p-3">
                                {user.self_assessments_initiated || 0} / {user.self_assessments_completed || 0}
                            </td>
                            <td className="p-3">
                                {user.assessment_360_initiated || 0} / {user.assessment_360_completed || 0}
                            </td>
                            <td className="p-3 space-y-2">
                                <button
                                    onClick={() => onSeeProfile(user.user_id)}
                                    className="text-blue-600 border border-blue-300 px-3 py-1 rounded-md hover:bg-blue-100 flex items-center"
                                >
                                    <Eye className="mr-2 h-4 w-4" /> See Profile
                                </button>
                                <button
                                    onClick={() => onSeeCampaigns(user.user_id)}
                                    className="text-green-600 border border-green-300 px-3 py-1 rounded-md hover:bg-green-100 flex items-center w-full"
                                >
                                    <ClipboardList className="mr-2 h-4 w-4" /> See Campaigns
                                </button>
                            </td>
                        </tr>
                    ))}
                    {users?.length === 0 && (
                        <tr>
                            <td colSpan="4" className="text-center p-4 text-gray-500">
                                No users found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default UserTable;
